"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuCheckboxUrsaSvg = void 0;
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _react = _interopRequireDefault(require("react"));
// This icon doesn't exist in ursa-icons intentionally - it's a one-off for the
// contact picker only.
const MenuCheckboxUrsaSvg = () => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.75 11.125L10.5 15.875L18.25 8.125",
    stroke: (0, _designTokensReact.color)("color--border--primary--default"),
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
exports.MenuCheckboxUrsaSvg = MenuCheckboxUrsaSvg;
//# sourceMappingURL=MenuCheckboxUrsaSvg.js.map